module.exports = __webpack_public_path__ + "media/brands/moto-guzzi-7855d6b5.png";